import React from 'react'
import Paper from '@material-ui/core/Paper'
import InputBase from '@material-ui/core/InputBase'
import Typography from '@material-ui/core/Typography'
import NumberFormat from 'react-number-format'

import classes from './TextFieldNumber.module.scss'
export default function TextFieldNumber(props) {
  const { label = '', required, readOnly, error, constainerStyle, onChange, ...other } = props
  const [focus, setFocus] = React.useState()

  const handleOnChange = e => {
    if (typeof onChange === 'function') onChange({ target: { value: e.floatValue } })
  }

  return (
    <div className={classes.root}>
      <Typography variant='subtitle2' className={classes.label}>
        {label}
        {!readOnly && required ? ' *' : ''}
      </Typography>
      <div className={classes.wrapper}>
        {readOnly ? (
          //  Read Only Value
          <Typography id={props.id} variant='subtitle2' className={`${classes.label} ${classes['read-only-value']}`}>
            {other.value}
          </Typography>
        ) : (
          <React.Fragment>
            <Paper
              style={constainerStyle}
              className={`${classes['text-field']} ${error ? classes['has-error'] : focus && classes.focus
                } box-shadow-field`}
              onBlur={() => setFocus(false)}
            >
              <NumberFormat
                id={props.id}
                className={classes.input}
                required
                customInput={InputBase}
                isNumericString
                displayType={'input'}
                allowLeadingZeros={false}
                value={other.value}
                onValueChange={handleOnChange}
                isAllowed={values => {
                  const { formattedValue, floatValue } = values
                  return formattedValue === '' || floatValue <= 1000000000
                }}
                autoComplete='off'
                onFocus={() => setFocus(true)}
              />
            </Paper>
            {error && <span className={classes.error}>{error}</span>}
          </React.Fragment>
        )}
      </div>
    </div>
  )
}
